module.exports = __webpack_public_path__ + "static/media/Screenshot26.c6a4cd26.jpg";